<ub-heading i18n>Login information</ub-heading>
@if (credentials$) {
  <div class="list">
    @for (cred of credentials$; track cred) {
      <eas-user-credential [credential]="cred"></eas-user-credential>
    }
  </div>
}
